<transaction-list-header-template
  (closeEmitter)="closeEmitter?.emit()"
  [activity]="activity"
  [canOpen]="canOpen"
  [transaction]="transaction">
  <ng-container symbol>
    @if (isActivityOrHistory()) {
      <img
        class="image-size"
        [src]="tradable?.getLogo()"
        (error)="img.src = '/assets/images/default-asset.svg'"
        alt="{{ 'logo_alt_text' | translate }}"
        #img />
    } @else {
      <span class="symbol-wallet">
        <span class="bpi__icon-tx-{{ getIconSuffix() }}" [ngClass]="{ isOpen: !canOpen }"></span>
      </span>
    }
  </ng-container>
  <ng-container status>
    @if (isWithdrawPending) {
      <span class="information-header-dot"></span>
    }
    @if (isSimpleInternalTx()) {
      @if (isSendProcessHeader()) {
        {{ getInternalSendKey() | translate: [currencySymbol] }}
      }
      @if (!isSendProcessHeader()) {
        @if (!isRefundTx()) {
          @if (isTrxCryptoMerger()) {
            {{ "tx_list_item_crypto_merger" | translate: [getTrxCryptoMergerFromSymbol, getTrxCryptoMergerToSymbol] }}
          } @else {
            {{ currencySymbol }} {{ transaction?.getType() + "_tx_type" | translate }}
          }
        }
        @if (isRefundTx()) {
          {{ "refund_tx_type" | translate: [currencySymbol] }}
        }
      }
    }
    @if (showStorageFee()) {
      {{ tradableName }} {{ "commodity_storage_fee" | translate }}
    }
    @if (showStorageFee(true)) {
      {{
      isBestMetalStorageFee()
      ? metalName + " " + ("commodity_storage_fee" | translate)
      : currencySymbol + " " + ("best_fee_collection_fee" | translate)
      }}
    }
  </ng-container>
  <ng-container transaction>
    @if (!isTrxCryptoMerger()) {
      {{ getRecipientPrefix() | translate }}:
    } @else {
      {{ getCryptoMergerRecipientPrefix | translate }}:
    }
    <!-- not clickable for extra details (popup) -->
    @if (!canOpen) {
      @if (isExternalAddress()) {
        <a [href]="urlCheckAddress" [target]="'_blank'">
          {{ getRecipient() }}
        </a>
      }
      @if (isRecipientBitpanda()) {
        {{ getRecipient() }}
      }
      @if (showBreakTagSection()) {
        @if (isBreakTagLink() && !hasDividendTag) {
          {{ transaction?.getFrom() }}
        } @else {
          <span [innerHtml]="breakTag(getRecipient())"></span>
        }
      }
      @if (isTrxCryptoMerger()) {
        {{ getTrxCryptoMergerDestination }}
      }
      @if (isTrxMarginTrading()) {
        {{ geTrxMarginTradingDestination }}
      }
      @if (transaction?.getType() === 'deposit') {
        {{
        "external_sender" | translate
        }}
      }
      @if (getRelatedWallet()?.isDeleted()) {
        <small class="text-small-gray">({{ "deleted" | translate }})</small>
      }
    } @else {
      @if (transaction?.getType() !== 'deposit') {
        @if (!transaction?.isTransfer()) {
          {{ getRecipient() | translate }}
        } @else {
          @switch (getTransferDisplayContent().type) {
            @case ("cryptoMerger") {
              {{ getTransferDisplayContent().content }}
            }
            @case ("marginTrading") {
              {{ getTransferDisplayContent().content }}
            }
            @default {
              @if (!getRelatedWallet()?.isDeleted()) {
                {{
                transaction?.isOutgoing() || isIncomingDividendTransaction()
                ? getRecipient()
                : transaction?.getFrom()
                }}
              } @else {
                {{ getRelatedWallet()?.getName() }}
                <small class="text-small-gray">({{ "deleted" | translate }})</small>
              }
            }
          }
        }
      } @else {
        {{ "external_sender" | translate }}
      }
    }
    @if (showDestinationTag) {
      <br />
      {{ getDestinationTagLabel() | translate }}: {{ transaction?.getDestinationTag() }}
    }
  </ng-container>
  <ng-container amounts>
    <div
      class="amount"
      [ngClass]="{ 'is-uncredited': isUncredited() }"
      hidePortfolioValue
      [isHideActive]="isWidget && (isHideValueActive$ | async)">
      <div
        class="amount-main"
				[ngClass]="{
					'is-cancelled': transaction?.isStatus('canceled'),
					isOpen: !canOpen,
					'price-up': !transaction?.isOutgoing()
				}">
        {{
        (storage_fee ? transaction?.getFee() : getTotalAmount())
        | tradable_precision_symbol: { id: getCurrencyId(), ignorePrecision: !canOpen }
        | value_change_prefix: { isProfit: !transaction?.isOutgoing() }
        }}
      </div>
    </div>
  </ng-container>
  <ng-container amountsExchanged>
    <div
      class="amount"
      [ngClass]="{ 'is-uncredited': isUncredited() }"
      hidePortfolioValue
      [isHideActive]="isWidget && (isHideValueActive$ | async)">
      <div
        class="amount-exchanged"
				[ngClass]="{
					'is-cancelled': transaction?.isStatus('canceled'),
					isOpen: !canOpen
				}">
        <span>
          {{
          amount === 0
          ? (getSpecialFeeFiat()
          | fiat_precision_symbol
          : {
          valueFirst: getFiatAmountConverted() < 0.01,
          id: fiat?.getId(),
          prefix: getFiatAmountConverted() < 0.01,
          notPrice: true,
          symbol: true,
          currencies: [fiat]
          })
          : (getFiatAmountConverted()
          | fiat_precision_symbol
          : {
          id: fiat?.getId(),
          prefix: amount === 0,
          symbol: true,
          currencies: [fiatForAmount]
          })
          }}
        </span>
      </div>
    </div>
  </ng-container>
</transaction-list-header-template>
